import { useEffect, useState } from "react";

// A short message after something is saved ("Saved", "Moved to 10:30"),
// bottom centre, gone after a few seconds. Screen readers hear it too.

type Item = { id: number; text: string };
let next = 1;
const listeners = new Set<(t: Item) => void>();

/** toast shows a short confirmation. */
export function toast(text: string) {
  const item = { id: next++, text };
  listeners.forEach((l) => l(item));
}

export function Toasts() {
  const [items, setItems] = useState<Item[]>([]);
  useEffect(() => {
    const add = (t: Item) => {
      setItems((list) => [...list.slice(-2), t]);
      setTimeout(() => setItems((list) => list.filter((x) => x.id !== t.id)), 2800);
    };
    listeners.add(add);
    return () => { listeners.delete(add); };
  }, []);
  return (
    <div className="toasts" role="status" aria-live="polite">
      {items.map((t) => <div key={t.id} className="toast">{t.text}</div>)}
    </div>
  );
}
